import { useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Link } from 'react-router-dom';

import Stack from '@mui/joy/Stack';
import Card from '@mui/joy/Card';

import Lore from 'components/Lore';
import useUserIdentity from 'hooks/useUserIdentity';
// import useTeam from 'hooks/useTeam';
import useMessages from 'hooks/useMessages';
import Typography from '@mui/joy/Typography';
import useChatRoom from 'hooks/useChatRoom';
import { Message } from 'stores/messages_store';
import LoadingSection from './LoadingSection';
import FancyIcon from './FancyIcon';
import { ChatBubbleSmall } from './ChatBubble';

const ChatActiveRoom = observer(({ uuid, recentMessages }: { uuid: string, recentMessages: Message[] }) => {
    const { getChatRoom } = useChatRoom();
    const room = getChatRoom(uuid);
    const LIMIT = 3;
    if (!room) {
        return <LoadingSection />;
    }

    var msgs = [...recentMessages];
    // sort by date_created
    msgs.sort((a, b) => {
        if (a.date_created > b.date_created) {
            return -1;
        }
        if (a.date_created < b.date_created) {
            return 1;
        }
        return 0;
    });

    msgs = msgs.slice(0, LIMIT);
    msgs.reverse();
    return (
        <Card>

            <Link to={`/chat/${room.uuid}`}>
                <Typography
                    startDecorator={<FancyIcon name="DayOnesChat" />}
                    level="title-lg">{room.name}</Typography>



                    <Stack spacing={1}>
                    {msgs.map((msg) => (
                        <ChatBubbleSmall
                            key={msg.uuid}
                            uuid={msg.uuid}
                            sender={''}
                            identityKey={msg.identity}
                            content={msg.content}
                            content_type={msg.content_type}
                            date_created={msg.date_created}
                            file_associations={[]}
                        />


                    ))}
                    </Stack>
                    </Link>
        </Card>
    );
});

const ChatHome = observer(() => {

    const { fetchRecentMessages } = useMessages();
    const { items } = useChatRoom()
    const { currentIdentity } = useUserIdentity();
    const [recentMessages, setRecentMessages] = useState([] as Message[]);
    const [activeRooms, setActiveRooms] = useState([] as string[]);
    useEffect(() => {
        if(items.length) {
        fetchRecentMessages(
            currentIdentity.uuid,
            'chat_room',
            items.map((item) => item.uuid),
        )
            .then((msgs) => {
                setRecentMessages(msgs);
            });
        }
        // fetchMyTeam();
    }, [items.length]);

    useEffect(() => {
        var tmp = [] as string[];
        recentMessages.forEach((msg) => {
            if (!tmp.includes(msg.associated_uuid)) {
                tmp.push(msg.associated_uuid);
            }
        });

        setActiveRooms(tmp);
    }, [recentMessages.length]);

    return (
        <Stack spacing={1}>

        <Typography level="title-lg">Active Chats</Typography>

        { (activeRooms.length > 0) &&
            activeRooms.map((room) => (
                <ChatActiveRoom
                    key={room}
                    uuid={room}
                    recentMessages={recentMessages.filter((msg) => msg.associated_uuid === room)}
                />
            ))
        }

            <Lore slug="feature/business/chat" />

         </Stack>
    );
});
export default ChatHome;
